import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import {
  dateTimeToDateFormat,
  dateTimeToPlainFormat,
  dateToPlainFormat
} from '@/utils'
import { CollectionFlag, Prefix } from '@/types'

export interface LendExtend {
  prefix: Prefix
  searchType: SystemCode
  id: number
  collectionNo: string
  displayTitle: string
  collectionType: SystemCode
  handlingType: SystemCode
  lendTime: string
  lendType: SystemCode
  dueDate: string
  extendCount: number
  extendDueDate: string
  hasReservation: boolean
  message: string
  canExtend: boolean
  collectionFlag: CollectionFlag
  revision: number
}

export function LendExtendFromJSON(json: any): LendExtend {
  return {
    prefix: json.prefix,
    searchType: exists(json, 'search_type')
      ? SystemCodeFromJSON(json.search_type)
      : defaultSystemCode(),
    id: exists(json, 'id') ? json.id : 0,
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    collectionType: exists(json, 'collection_type')
      ? SystemCodeFromJSON(json.collection_type)
      : defaultSystemCode(),
    handlingType: exists(json, 'handling_type')
      ? SystemCodeFromJSON(json.handling_type)
      : defaultSystemCode(),
    lendTime: exists(json, 'lend_time')
      ? dateTimeToDateFormat(dateTimeToPlainFormat(json.lend_time))
      : '',
    lendType: exists(json, 'lend_type')
      ? SystemCodeFromJSON(json.lend_type)
      : defaultSystemCode(),
    dueDate: exists(json, 'due_date') ? dateToPlainFormat(json.due_date) : '',
    extendCount: exists(json, 'extend_count') ? json.extend_count : 0,
    extendDueDate: exists(json, 'extend_due_date')
      ? dateToPlainFormat(json.extend_due_date)
      : '',
    hasReservation: exists(json, 'has_reservation')
      ? json.has_reservation
      : false,
    message: exists(json, 'message') ? json.message : '',
    canExtend: exists(json, 'can_extend') ? json.can_extend : false,
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : CollectionFlag.NotCollection,
    revision: json.revision
  }
}
